import { ReactNode } from "react";
type Column<T> = {
    header: ReactNode;
    accessor: string;
    render?: (value: any, row: T) => ReactNode;
    cellClassName?: string;
    headerClassName?: string;
};

export const getValue = (obj: any, path: string) =>
    path.split(".").reduce((acc, part) => acc?.[part], obj);

export const convertToCSV = <T>(data: T[], columns: Column<T>[]): string => {
    const headers = columns.map((col) =>
        typeof col.header === "string"
            ? col.header
            : typeof col.header === "number"
                ? col.header.toString()
                : ""
    );

    const rows = data.map((row) =>
        columns.map((col) => {
            const value = getValue(row, col.accessor);
            const rendered =
                col.render?.(value, row) ??
                (typeof value === "string" ? value : JSON.stringify(value));
            return `"${rendered?.toString().replace(/"/g, '""')}"`;
        })
    );

    return [headers, ...rows].map((r) => r.join(",")).join("\n");
};

export const downloadCSV = (csv: string, filename: string = "data.csv") => {
    const blob = new Blob(["\uFEFF" + csv], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", filename);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};
